import React from 'react';
import PropertyCreationWizard from '../components/wizard/PropertyCreationWizard';

const PropertyWizardPage = () => {
  return <PropertyCreationWizard />;
};

export default PropertyWizardPage;
